// Mock wine-related news data
export const newsArticles = [
  {
    id: 1,
    website: "Wine Spectator",
    websiteIcon: "https://www.winespectator.com/favicon.ico",
    title: "Napa Valley Cabernet Prices Hit Record High",
    secondaryTitle: "Premium vineyard land now exceeds $400,000 per acre",
    text: "The latest report from Silicon Valley Bank indicates that prime vineyard land in Napa Valley has reached unprecedented prices, with some recent sales exceeding $400,000 per acre. Industry experts attribute this inflation to increased demand from luxury wine producers and...",
    category: "Business",
    tags: ["Napa Valley", "Cabernet Sauvignon", "Real Estate"],
    author: "Sarah Thompson",
    imageUrl: "https://images.unsplash.com/photo-1560493676-04071c5f467b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80",
    publishedAt: "2025-05-02T11:01:56-04:00",
  },
  {
    id: 2,
    website: "Decanter",
    websiteIcon: "https://www.decanter.com/favicon.ico",
    title: "Climate Change Shifting Wine Regions Northward",
    secondaryTitle: "Traditional regions struggle while new areas emerge",
    text: "A comprehensive study published in Nature Climate Change reveals that traditional wine-growing regions in Southern Europe are experiencing increasingly challenging conditions, while regions previously considered too cold for viticulture are now producing award-winning wines...",
    category: "Environment",
    tags: ["Climate Change", "Viticulture", "New Regions"],
    author: "James Morrison",
    imageUrl: "https://images.unsplash.com/photo-1587049633312-d628ae50a8ae?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80",
    publishedAt: "2025-05-06T11:01:56-04:00",
  },
  {
    id: 3,
    website: "Wine Enthusiast",
    websiteIcon: "https://www.winemag.com/favicon.ico",
    title: "Natural Wine Movement Gains Mainstream Acceptance",
    secondaryTitle: "Major retailers now dedicating shelf space to low-intervention wines",
    text: "What was once considered a fringe movement has now entered the mainstream, with major retailers like Whole Foods and Total Wine dedicating significant shelf space to natural, organic, and biodynamic wines. Consumer interest in low-intervention winemaking has surged in the past year...",
    category: "Trends",
    tags: ["Natural Wine", "Organic", "Biodynamic"],
    author: "Elena Rodriguez",
    imageUrl: "https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80",
    publishedAt: "2025-05-08T00:50:00-04:00",
  },
];